import React from 'react';

/**
 * **붙어 있는 고르개** — 한 묶음의 보기를 한 덩어리로 보여 준다.
 *
 * 통계 탭의 거르개가 알약 여섯 개로 흩어져 있어서, 어느 것이 같은 묶음인지(시즌인지 길드인지
 * 성급인지) 눈으로 가릴 수 없었다. 묶음끼리 붙이고 왼쪽에 작은 이름표를 달면 세 덩어리로
 * 읽힌다. 고른 것만 보라색으로 채운다.
 *
 * 값은 무엇이든 될 수 있다(시즌은 `number | null`, 길드는 `'opp' | 'own'`). 그래서 `value` 는
 * 그대로 비교(`===`)하고, 보기마다 `value` 를 들고 있게 한다.
 */

export interface SegmentedOption<T> {
    value: T;
    label: string;
}

interface Props<T> {
    /** 왼쪽에 붙는 작은 이름표. 없으면 안 그린다 */
    label?: string;
    options: Array<SegmentedOption<T>>;
    value: T;
    onChange: (v: T) => void;
    isMobile?: boolean;
}

function Segmented<T>({ label, options, value, onChange, isMobile = false }: Props<T>) {
    return (
        <div style={{ display: 'inline-flex', alignItems: 'center', gap: isMobile ? 6 : 8 }}>
            {label && (
                <span style={{
                    fontSize: isMobile ? 11 : 12, fontWeight: 700, color: '#aab',
                    whiteSpace: 'nowrap', letterSpacing: 0.2,
                    // 세로로 쌓을 때 고르개들이 같은 자리에서 시작하도록 이름표 너비를 맞춘다
                    minWidth: isMobile ? 30 : 34, textAlign: 'right'
                }}>{label}</span>
            )}
            <div style={{
                display: 'inline-flex',
                borderRadius: 999,
                overflow: 'hidden',
                border: '1px solid rgba(102, 126, 234, 0.22)',
                background: 'rgba(102, 126, 234, 0.06)'
            }}>
                {options.map((o, i) => {
                    const on = o.value === value;
                    return (
                        <button
                            key={i}
                            onClick={() => onChange(o.value)}
                            style={{
                                border: 'none',
                                /*
                                  단추 하나의 크기를 못박는다 — 묶음마다 글자 수가 달라
                                  ("전체" vs "5성") 폭이 제각각이면 세로로 쌓았을 때 줄마다
                                  단추 크기와 자리가 어긋나 보인다.
                                */
                                width: isMobile ? 52 : 66,
                                padding: isMobile ? '6px 0' : '8px 0',
                                background: on ? 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)' : 'transparent',
                                color: on ? '#fff' : '#667eea',
                                fontSize: isMobile ? 12 : 13,
                                fontWeight: 700,
                                cursor: 'pointer',
                                transition: 'all 0.2s ease',
                                whiteSpace: 'nowrap'
                            }}
                        >{o.label}</button>
                    );
                })}
            </div>
        </div>
    );
}

export default Segmented;
